import { Eye } from 'lucide-react';

import { Button } from '@/components/ui/Button';
import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogTitle,
  DialogHeader,
  DialogDescription,
} from '@/components/ui/Dialog';

interface JsonViewerDialogProps {
  data: Record<string, any> | null;
  triggerText?: string;
  title?: string;
  triggerVariant?:
    | 'default'
    | 'outline'
    | 'ghost'
    | 'link'
    | 'destructive'
    | 'secondary';
  triggerSize?: 'default' | 'sm' | 'lg' | 'icon';
}

export function JsonViewerDialog({
  data,
  triggerText = 'View JSON',
  title = 'JSON Details',
  triggerVariant = 'outline',
  triggerSize = 'sm',
}: JsonViewerDialogProps) {
  if (!data || Object.keys(data).length === 0) {
    return <span className="text-sm text-gray-500">No data</span>;
  }

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button
          variant={triggerVariant}
          size={triggerSize}
          className="text-gray-700 hover:border-gray-300 hover:bg-white"
        >
          <Eye className="mr-1 h-4 w-4" />
          {triggerText}
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <DialogDescription className="sr-only">
          Este modal exibe os dados do usuário selecionado.
        </DialogDescription>
        <div className="mt-4">
          <pre className="max-h-96 overflow-auto whitespace-pre-wrap rounded-md bg-gray-100 p-4 text-sm">
            <code>{JSON.stringify(data, null, 2)}</code>
          </pre>
        </div>
      </DialogContent>
    </Dialog>
  );
}
